import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { LockCardConfirm } from './LockCardConfirm';
import { LockCardPlaced } from './LockCardPlaced';

import { LockCardStackParamList, LockCardStackRoutes } from './type';

const LockCardStack = createNativeStackNavigator<LockCardStackParamList>();

export const LockCardNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.LockCard>> = ({ route }) => {
  const { account, tab, record, func, actionResponse, actionError, refresh } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [type, setType] = useState<string | undefined>(undefined);
  const [data, setData] = useState<any>(undefined);
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const onType = (value: string | undefined) => {
    setType(value);
  };

  const onData = (value: any) => {
    setData(value);
  };

  return (
    <ModalContainerView dimensions={dimensions} nativeFlag={false}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <LockCardStack.Navigator
          initialRouteName={LockCardStackRoutes.Confirm}
          screenOptions={{
            presentation: 'transparentModal',
            headerShown: false,
            contentStyle: {
              backgroundColor: 'transparent'
            }
          }}>
          <LockCardStack.Screen
            name={LockCardStackRoutes.Confirm}
            component={LockCardConfirm}
            initialParams={{ onLayout, account, tab, onType, record, func, actionResponse, actionError, onData, refresh }}
            options={{ headerShown: false }}
          />
          <LockCardStack.Screen
            name={LockCardStackRoutes.Placed}
            component={LockCardPlaced}
            initialParams={{ onLayout, account, tab, type, record, data, refresh }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </LockCardStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
